export default __webpack_public_path__ + "static/media/swap.c3654462.svg";